import React, { useEffect } from 'react'
import './alert-message.css'
import { InformationIcon } from '@paypalcorp/pp-react'

export interface IAlertMessageProps {
  type?: 'info'
  title?: string
}
export const AlertMessage: React.FC<IAlertMessageProps> = ({
  type = 'info',
  title,
  children,
}) => {
  const className = `alert_message-${type}`

  const defaultTitle = {
    info: 'Note: ',
  }

  return (
    <>
      <div className={`alert_message ${className}`}>
        <InformationIcon className={`${className}-icon`} />
        <p>
          <b style={{ marginRight: '0.2em' }}>
            {title ? { title } : defaultTitle[type]}
          </b>
          {children}
        </p>
      </div>
    </>
  )
}

export default AlertMessage
